import React, { useEffect } from "react";
import { Editor } from "@monaco-editor/react";
import { Directory } from "../shared";
import { FS } from "@/singletons/FileSystem";

export function FSViewer() {
  const [activeFile, setActiveFile] = React.useState<string | null>(null);
  const [files, setFiles] = React.useState<string[]>([]);
  const [fileContent, setFileContent] = React.useState<string | null>(null);

  useEffect(() => {
    FS.list("/").then((result) => setFiles(result));
  }, []);

  useEffect(() => {
    if (activeFile) {
      FS.read(activeFile).then((content) => setFileContent(content));
    } else {
      setFileContent(null);
    }
  }, [activeFile]);

  const pathToLanguage = (path: string) => {
    const ext = path.split(".").pop();
    switch (ext) {
      case "ts":
        return "typescript";
      case "tsx":
        return "typescriptreact";
      case "js":
        return "javascript";
      case "jsx":
        return "javascript";
      case "json":
        return "json";
      case "css":
        return "css";
      case "html":
        return "html";
      case "py":
        return "python";
      case "xml":
        return "xml";
      default:
        return "json";
    }
  };

  return (
    <div className="w-full h-full flex bg-slate-700">
      <div className="w-96 flex">
        <Directory
          files={files}
          onSelect={(keys, info) => {
            if (info.node.isLeaf) {
              setActiveFile(info.node.key as string);
            }
          }}
        />
      </div>
      <div className="flex-1 overflow-auto p-2 border-l border-white">
        {activeFile && fileContent ? (
          <Editor
            key={activeFile}
            height="100%"
            defaultLanguage={pathToLanguage(activeFile)}
            value={fileContent}
            onChange={(value) => FS.write(activeFile, value || "")}
            options={{ readOnly: false }}
          />
        ) : (
          <div className="text-slate-400">Select a file to view details.</div>
        )}
      </div>
    </div>
  );
}
